import { format, isToday, isTomorrow, isYesterday } from "date-fns";

function getHumanReadableDate(dateString: string): string {
  const date = new Date(dateString);

  if (isToday(date)) {
    return "today";
  }

  if (isTomorrow(date)) {
    return "tomorrow";
  }

  if (isYesterday(date)) {
    return "yesterday";
  }

  return format(date, "MMMM do");
}

function getHumanReadableTime(timeString: string): string {
  const time = new Date(timeString);

  return format(time, "h:mm a");
}

function isMeetingWithin10Minutes(meetingTime: string): boolean {
  // const meetingDateTime = new Date(meetingTime);
  // const now = new Date();
  // const diff = meetingDateTime.getTime() - now.getTime();

  // const timeDifference = now.getTime() - meetingDateTime.getTime();
  // const differenceInHours = timeDifference / (1000 * 60 * 60);

  // // return true;
  // return diff > 0 && diff <= 60 * 60 * 1000 || differenceInHours > 0 && differenceInHours < 1;

  const currentTime = new Date();
  const meetingDateTime = new Date(meetingTime);
  const differenceInMinutes =
    (meetingDateTime.getTime() - currentTime.getTime()) / (1000 * 60);
  console.log(
    "🚀 ~ isMeetingWithin10Minutes ~ differenceInMinutes:",
    differenceInMinutes
  );

  return differenceInMinutes <= 30 && differenceInMinutes > 0;
}

function countdownTime(meetingTime: string): string {
  const meetingDateTime = new Date(meetingTime);
  const now = new Date();
  const diff = meetingDateTime.getTime() - now.getTime();

  const timeDifference = now.getTime() - meetingDateTime.getTime();
  const differenceInHours = timeDifference / (1000 * 60 * 60);

  return diff.toString();
}

const formatDateTime = (
  date: string,
  time: string,
  type: "date" | "time" | "datetime"
) => {
  const [hours, minutes] = time.split(":");
  const utcDateTime = new Date(`${date}T${hours}:${minutes}:00Z`);
  // Convert UTC date and time to local date and time
  const localDateTime = new Date(utcDateTime);
  if (type === "date") {
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDate = localDateTime.toLocaleDateString(undefined, options);
    return formattedDate;
  } else if (type === "time") {
    const localTime = localDateTime.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return localTime;
  } else return localDateTime.toISOString();
};

const readableDateTime = (date: string) => {
  const localDateTime = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    // weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return `${localDateTime.toLocaleDateString(
    undefined,
    options
  )} ${localDateTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })}`;
};

const convertLocalTimeToUTC = (date: string, time: string) => {
  const [hours, minutes] = time.split(":");
  const localDateTime = new Date(`${date}T${hours}:${minutes}:00`);
  const utcDateTime = new Date(localDateTime.toUTCString());
  console.log(
    "🚀 ~ convertLocalTimeToUTC ~ utcDateTime:",
    utcDateTime,
    utcDateTime.toISOString()
  );
  return utcDateTime.toISOString();
};

const convertUTCToLocalTime = (date: string) => {
  const utcDateTime = new Date(date);
  const localDateTime = new Date(utcDateTime);
  return localDateTime.toISOString();
};

const convertISODateToLocalDate = (dateString: string) => {
  return `${dateString.split("T")[0]}:${dateString.slice(11, 16)}`;
};

 

export {
  getHumanReadableDate,
  getHumanReadableTime,
  isMeetingWithin10Minutes,
  countdownTime,
  formatDateTime,
  readableDateTime,
  convertLocalTimeToUTC,
  convertUTCToLocalTime,
  convertISODateToLocalDate,
};
